export const isAuthenticated = (state) => {
  return !!state.auth?.token || !!state.auth?.user;
};
